import { useState } from 'react';
import { Link } from 'react-router-dom';
import { varietyShows } from '@/mocks/varietyData';

export default function HotShowsSection() {
  const [activeTab, setActiveTab] = useState<'hot' | 'new'>('hot');

  const filteredShows = varietyShows.filter((show) =>
    activeTab === 'hot' ? show.isHot : show.isNew
  );

  return (
    <section className="py-10 md:py-16 bg-background-100">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between mb-8 md:mb-10 gap-4">
          <div>
            <h2 className="text-xl md:text-3xl font-heading text-foreground-900 mb-2">
              {activeTab === 'hot' ? '热门综艺' : '最新上线'}
            </h2>
            <p className="text-sm text-foreground-600">
              {activeTab === 'hot' ? '大家都在看的热门综艺节目' : '最新上线的综艺节目，抢先看'}
            </p>
          </div>
          <div className="flex bg-background-200 rounded-full p-1">
            <button
              onClick={() => setActiveTab('hot')}
              className={`px-5 py-2 rounded-full text-sm font-medium transition-all whitespace-nowrap cursor-pointer ${
                activeTab === 'hot'
                  ? 'bg-primary-500 text-white'
                  : 'text-foreground-600 hover:text-foreground-800'
              }`}
            >
              热门推荐
            </button>
            <button
              onClick={() => setActiveTab('new')}
              className={`px-5 py-2 rounded-full text-sm font-medium transition-all whitespace-nowrap cursor-pointer ${
                activeTab === 'new'
                  ? 'bg-accent-500 text-white'
                  : 'text-foreground-600 hover:text-foreground-800'
              }`}
            >
              最新上线
            </button>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-5" data-product-shop>
          {filteredShows.map((show) => (
            <Link
              key={show.id}
              to={`/article/${show.id}`}
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
              className="group bg-background-50 rounded-lg overflow-hidden border border-background-200/70 transition-all hover:scale-[1.02] cursor-pointer"
            >
              <div className="relative w-full h-40 md:h-48 overflow-hidden">
                <img
                  src={show.imageUrl}
                  alt={show.title}
                  title={`${show.title} - 香蕉影视综艺娱乐免费高清在线观看`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3 flex gap-2 flex-wrap">
                  {show.isHot && (
                    <span className="bg-primary-500 text-white text-xs px-2 py-0.5 rounded-full font-medium">
                      热门
                    </span>
                  )}
                  {show.isNew && (
                    <span className="bg-accent-500 text-white text-xs px-2 py-0.5 rounded-full font-medium">
                      新上
                    </span>
                  )}
                </div>
                <div className="absolute bottom-2 right-2 bg-black/60 text-white text-xs px-2 py-0.5 rounded-full">
                  共{show.episodes}期
                </div>
              </div>
              <div className="p-3 md:p-4">
                <h3 className="text-sm md:text-base font-semibold text-foreground-800 mb-2 line-clamp-1 group-hover:text-primary-600 transition-colors">
                  {show.title}
                </h3>
                <p className="text-xs text-foreground-500 mb-3 line-clamp-2 leading-relaxed">
                  {show.description}
                </p>
                <div className="flex items-center justify-between">
                  <span className="text-xs text-foreground-400">{show.updateDay}更新</span>
                  <div className="flex items-center gap-1">
                    <div className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-star-fill text-xs text-amber-400"></i>
                    </div>
                    <span className="text-xs font-semibold text-foreground-700">{show.rating}</span>
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}